
import React from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import  ROUTES  from './routes';

const Navigation = () =>
(
    <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
        <Navbar.Brand href="/">🌩️ Lightning Laptop</Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="mr-auto">
                {ROUTES.map((r, i)=>(<Nav.Link key={i} href={r.path}>{r.title}</Nav.Link>))}
            </Nav>
        </Navbar.Collapse>
    </Navbar>
)

export default Navigation;
